import { render, staticRenderFns } from "./TransferForm.vue?vue&type=template&id=a7f33cfa&scoped=true"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"
import style0 from "./TransferForm.vue?vue&type=style&index=0&id=a7f33cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f33cfa",
  null
  
)

export default component.exports